var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseRoundedNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.371397,
    y: 0.371397,
    width: 39.2572,
    height: 39.2572,
    rx: 19.6286,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.371397,
    y: 0.371397,
    width: 39.2572,
    height: 39.2572,
    rx: 19.6286,
    stroke: "#0F2A59",
    strokeWidth: 0.742794
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8828 27.6445L28.1134 12.3757",
    stroke: "#0F2A59",
    strokeWidth: 2.41408
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6406 28.1211L12.3718 11.8905",
    stroke: "#0F2A59",
    strokeWidth: 2.41408
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRoundedNew);
export default __webpack_public_path__ + "static/media/close-rounded-new.08370733735820669c4fb752b181b013.svg";
export { ForwardRef as ReactComponent };